export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('firebase-messaging-sw.js')
      .then(function(registration) {
        console.log('[SW]: SCOPE: ', registration.scope)
        return registration.scope
      })
      .catch(function(err) {
        return err
      })
  }
}

export const unregisterFirebaseServiceWorker = () => {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      console.log(
        `> Unregistering service worker: ${registration.active.scriptURL}`
      )
      if (
        registration.active.scriptURL ===
        `${process.env.REACT_APP_URL}/firebase-messaging-sw.js`
      )
        registration.unregister()
    }
  })
}
